export enum FeatureToggle {
  InstallStoresAppV3 = 'storesOnboardingInstallStoresAppV3',
  CreateSingleProduct = 'storesOnboardingCreateSingleProduct',
}

export const featureToggleIds = [FeatureToggle.InstallStoresAppV3, FeatureToggle.CreateSingleProduct];
